export default __webpack_public_path__ + "static/media/Senior_Grandmaster_Mentor.488db06e.png";